'use client'

import { useEffect } from 'react'

type Props = {
  hasUnsavedChanges: boolean
}

export function useBlockCloseWindow({ hasUnsavedChanges }: Props) {
  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      if (hasUnsavedChanges) {
        event.preventDefault()
        return ''
      }
    }

    window.addEventListener('beforeunload', handleBeforeUnload)
    return () => window.removeEventListener('beforeunload', handleBeforeUnload)
  }, [hasUnsavedChanges])
}

export function BlockCloseWindow({ hasUnsavedChanges }: Props) {
  useBlockCloseWindow({ hasUnsavedChanges })
  return null
}
